<script>
import { defineComponent } from "vue";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

pdfMake.addVirtualFileSystem(pdfFonts);

export const IconLogoBase64 = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgAAZABkAAD/7AARRHVja3kAAQAEAAAAZAAA/+4ADkFkb2JlAGTAAAAAAf/bAIQAAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQICAgICAgICAgICAwMDAwMDAwMDAwEBAQEBAQECAQECAgIBAgIDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMD/8AAEQgAyADIAwERAAIRAQMRAf/EAJwAAQACAwEAAwEAAAAAAAAAAAAFCAYHCQoCAwQBAQEAAwEAAAAAAAAAAAAAAAAAAQIDBBAAAQQCAQMCAggCBwcDBQAAAgEDBAUABgcREgghEzFBUSIUtBV1NgkytmFxQnIjMziyFnYXN3cY8JGxoVJiNDURAQEAAgEEAQQCAgMBAQAAAAABEQIxIRIyA0FRYXGBIhMzQ5HBQtFy/9oADAMBAAIRAxEAPwC/+x/qG9/ObT76/ndOHKhskMBgMBgMBgMBgMBgMBgMBgMBgMBgMBgMBgMCZ2P9Q3v5zaffX8icCGyQwGAwGAwGAwGAwGAwGAwGAwGAwGAwGAwGAwJnY/1De/nNp99fyJwIbJDAYDAYDAYDAYDAYDAYDAYDAYDAYDAYDAYDAmdj/UN7+c2n31/InAhskMBgMBgMBgMBgMBgMBgMBgMBgMBgMBgMBgMCZ2P9Q3v5zaffX8icCGyQwGAwGAwGAwGAwGAwGAwGAwGAwGAwGAwGAwJnY/1De/nNp99fyJwIbJDAYDAYDAYDAYDAYDAYDAYDAYDAYDAYDAYDAmdj/UN7+c2n31/InAhskMBgMBgMBgMBgMBgMBgMBgMBgMBgMBgMBgMCZ2P9Q3v5zaffX8icCGyQwGAwGAwGAwGAwGAwGAwGAwGAwGAwGAwGAwJnY/1De/nNp99fyJwIbJDAYDAYDAYDAYDAYDAYDAYDAYDAYDAYDAYDAmdj/UN7+c2n31/InAhl9PX/AOMkWv0vw25S5ESIGmbfwjezpcJmeNNE5ObO8YYeYSQoyasKI5AOx2+qPCPejZIqKvzyl9ms5z/wtNLeMNin+2z5QNgbjkXjVttsSMzPeZIgACikRmRa2giIinVVX0RMr/bp90/17K38j8I7DxhXhYXW5cUX6lZDVuVui741tNtGkE086rsmGzWRAbhteyom4jhIJkKdPX0vNptxKrZj6NN5ZDNtB423zlK8HXOPdVt9rtvqk+zWR+6PBaLqqP2U91WoNez2opdXXBUkRe1C6dMi2TrSS24i7sH9uTfKysj2nKfLfF3FgPkipFtJh2bhAKiTjbcx6dRxTko2q/VH3EEv/uTMr7ZxrLWn9d+bH4i8DoF8rzfG3ktw/uVkhixEopDyVVhNlKP+Sy+FtM7+930FQjl0RU+K5P8AZjylOzPFjRdj4j+QFLyFQcdXPHd2xP2C2jV0S9rozlzq6RnHwbmWxXkICiMwoDHc6X2hWDNA6CnVUy3frZlXt2zhqvlPRHeMOSN147fsW7h7TL6TRO2jUcojc84zbLiyAjG46TAl73TtUi+Hxy2tzMosxcMByUNu8T8Ecr83WCweONRm3LDTyMzb2Sv4drdafcgkk26kD7CGCr9YGUedH5imV22115TJbwtof7fh60Laco+RXEuh2CCCyqJXPt1lHV0BJpe+Ta1xkBKXx+zdFT19Mp/bnxlq3Z9bH2zf25txtq+VY8UcxcX8pLHTv/D6+X+GyABR6ti/Njz7qK284qKiIYNp19PT45H9s/8AUsT2X4sqjm+cdbzxffOazyBq9tqtyCEbUazj9jU1kV6faa6a0rkOwjKnRe5oy7UVO5BX0zWWWZillnLEWGlffYjibbZSH2WBceP22WyecFoXHnOi+2yCn1Mui9ooq9MlC4us+CnNO6o8Wm7LwjtSRkVZKUHKAWTkZENAVZDMfXyeZHvVEQiFBXr6Lmd9ms5z/wALTS3jCK5Q8IvIPiLTrLe9qpNbma7Te0ds7q+wPXc2uiuGgFYSYTlTAJK+OSp7zgkXtovVU6dVSZ7NNricl02nVUrLqmBvDjjgLaOUa2PY0G58R1Lkue/WxqbceQGdbv35LAtF3N1rtXKRWH/eRGi9zq4SKiJ1TK3aa85WmtvGG9bf9u/yLoK+Rb30niakqoYocuztuQzgQIoEQgJSJcnXm2WkIyRE6r6qqInquV/t0v1/4T2bfZVbkDj6w46tIdTY7Ho+yuzYI2ATND2VNnrGGyfejpHlzEgwPYmoTCkrfavQCFevr0y8ufqrZhgeShM7H+ob385tPvr+ROBDZI2dwfazNe5n4nuKt040yLyPpI97DhsE9GkbLWR5sJ1xlRcWNOiOG06PXoQGqZXfxv4Tr0seiPzOvrDXfF7l21rHnI0xaCvrheZdNlwGLzYaakmIDjaiYqUOxcT0VOqLnL65neRvvca2vMWLYB/AAj6dOoiiL0/pVE6rnY528PH3g3Y/IPkmt0KhcKBDRtbTadgVn3mte15hwW5E3sLo27OkuEjMVol6G6XcqKAHld9prrlOsu1w7R81b3x74F8IVes8XUFY1tl8jlZrEeWKPSrGfGZD8T2/Z5IokizKH76GqGSI684gD0BCROfXW+zbO3Da2aa9OXBndd53Dka6l7DvWx2uz2815X3pFrKckNtmvogRIpF9lhstj9UAbAUEfTOmSThjbbyxRpPYdB9hVjvtqhNPxyJh9ok+BNPNKDrRJ8lFUVMlDrB4K+Z2zQ9opuFuVrqRe0OwOpX6XtNtIV6zo7bs6Q9fsZjq98yqsUD24xuKpsvdodVEk6Yez1zHdq10264qpnm7A/D/ACi5VDqq/arODY+rft9PttdHc6InRO9E7f4v7WX9fhFNpjapHw/8X53kdu75WxSq/jbUzjv7ZZx1Vt+ykuqjsTWa15UVBkzG0U33E9WWPVPrEOPZv2T7p117r9nQnzO8hIHjRqFBwLwXGr9Rv51UL0l+lYaZ/wBzdaNSZaOIIoqheXJgXtvH3GICTnVSVFTL16d97tuF99u3+McQJ8qVazH7G1lSbSwkmTkmfYvuzZj7hqpEbsmSTjpqqr816JnSxZFpW77dxxewtl0XYLLWbqA6jzEuskGwDip/E1Miiv2abHcH6ptuiQkKqmRZL0qZbOHe/jC7478/fHt2ByJTwh2ipcWm2FyA2DVlrWzNR++FsmvySRXoTNi3/jAHXsLobZIoomc20vq26cNpjedeXEDm7h3Z+CeRbrjzaESQ9AUZdPcNtK3F2ChlEf4fbRx/hAnBBQebT/KfAh6Inb16NdptMxjZi4YbpW7bRxtsVdt+lW8uhvqh8JcaVCdJoHVaXuWPNYFUamw3h6ibTiEJCq+mTZLMXglxcx6p+PbteQuL9Nu9iiQHnty0ils7qtRpHID63VRGesGEjPd/fDcKSQ9pdU7V6LnFelxHRLmdXA3zS8VJfj9uC7Hq8R13iXbZri0Twqbv+6ts8pPParONUVW4y+p17hL0NpFa69zad3V69+6Yvkx317eOFI80UfFRRFRxERHA6EBoid4kK9wkJfxCor6oqfBcDrL5q7XdWXiH4qxJkyQ+mw12sWd065JeN2zl1Ohiyy5PUiVJavPTifNXO7/GRC+Kdcw9cxvt9mm1/hHJoREU6CIin0CiIn/0zdm+WBM7H+ob385tPvr+ROBDZIzziv8A6pcY/wDcbRf5qqcrt438JnL0N+dn+kzlv8v1X+eNXzm9X+SNvZ4V5qM62D0B/ts8XRdO4LTepEUQ2Dk60lWz0gwT3w16rkP1mvxAcVEX7K80y5MRPh3ylzl9u2dsfEb+uYmfmub/AO4XvsncvJDYKn31cqtDrazVq1rooo08LA2Fx3D8CNbaW6iF8wRE+Wa+qY0z9Wfsv8lHM1UMD7GZEqI+xLgyDiTob7EyDLaVUdiTYjoSIkptU6KjkeQ2Jj/SOBuDyB5cZ5o5Ck8jrVy6iRL1bVqy2jTJEeSb1rr1M1X2Viy7HRBGLYPNK6Al/iD1Xuyus7Zj7p2ubl6E/D/i+NxP4/6DRJHBm2tqpjadidER75N1sDQT5BmSIhELTLgNgi9VERRM5d9u7a1vrMR5/fJvdXuQefuVNnckOSGHNrn1FZ7hdyx6uhP8KixAX16NMnGcVE+SkudWkxrIx2udrWissqYHSL9sXdX6PnG800nTWFu+ozXBje4SMpY64YWIS/bT6hP/AGJXG+q+vaS9Mx90zrn6NPXeuFsP3QeM4d1xZrnKUeOA3GiX8WqmSQFFef1/aH24BxjXp1VqPbLHe6/2URfkq5T03r2/Vb2Tpn6OFTn+W5/cL/ZXOli7O868y7bwVxr4Vb7qT6k5D1iAxc07rhjA2Gkd1GpWbUzhD+y6CdWnOiky6gmPqmc+us2u0v1a29slX+prXivy04VV4mGL7St3qyiWVc+Tf2+lswEVfiPEHU4F5STOhtuD0VCEXB6iSdcv5evb7xfptPs87nkPwNtHjzyJO0u+RybVSUdsdQ2NG+yPsVArnY0/6dRbsoJEjMtpF+o4iEn1DHOrTabzLHbW61olfgv9S/8Axl1XUHzH/wBJ3h5/w9W/yZAzH1+e35abeEcv82ZmBM7H+ob385tPvr+ROBDZIzziv/qlxj/3G0X+aqnK7eN/CZy9DfnZ/pM5b/L9V/njV85vV/kjb2eFeacl6CSp8URV/wDZM62D1TeNcJiu8feF4UVFRiNxnprbfVUUlRKKEqkZJ/EZkqqq/NV65xb+d/Lo18Z+HnM8m3nH/Inm510HWzXk3bU9t4u420G0eEQVeqoiCKJ0RPRE+GdenhPww28q0blkGAwPk2IuOstmKGDj7DZgqdUMDeATBU+aEKqi4Lw9dusp7Wo6+jY9vt65Uo2Ip6D2VkftFE/o6Zw3mun4eS7ayM9t243OvuHtu0G6pJ0JXDvrAnFJOidCU1Xr/TnbOJ+HMgckMC4HgbLeh+U3G5s9vV8NghOdydyezKp5DbvT6C7fgvyzP2+FW08nZXzvbbc8WeUvcAT7K6A4HcnXtcC0hk2afQQEnVF+nMPV5xrv415p3P8ALc/uF/srnWwdQ/OH/Tt4g/8ACkH+TqvMfV5bNNvGK5+I/k7beOm8iU1yTN442aRHj7lTNdzpR0RfaZ2KtZVeiWNaJqpCPRX2eoL69qpb2ad06eSNdu2/Z3P5w4d0Dyr4kbrRnwJIWENrYuPd3gIEpaqxejKcCyiPB9d6unNOe1LY6ojrJEKohiKjz67XTZrtJtHmp37Rdo4z26+0Xcq46vY9elnDnxl6ky6PTujzoL3RBlV09hUdYdH6pgX0oqJ1yyzM4YWWXFdE/Mf/AEneHn/D1b/JkDMvX57flfbwjl/mzMwJnY/1De/nNp99fyJwIbJGecV/9UuMf+42i/zVU5Xbxv4TOXob87P9JnLf5fqv88avnN6v8kbezwrzUZ1sHpd8HN0i7r4x8YOMuicnWKZNIsW+qq6zK1Nwqdv30JVJDkw4zTwqv8QOCXwXOP2TG9dGnXWOKXm9p0nTfJrkxp1pwY+x2je3wnzBRbktbHHbsHyYJfRwI8txxolT4GCpnT67nSMd+myp+XVMBgfS6iPNPtAfQlA21IC6E2ZCqIvUV6gYqvVPgqYHqv8AHbeoXJHCXGm3QnANLDU6lmW2J95RrCvitwJ0Z/1VQkMyYxIYr6oucW07drHTrczLzY8+aq9pPNvKusPAQLW7zfONqSKiOsWUw7Zl4FX1JtwJ3ovzzr1udZfs59pi4akyyDAvh+3Fr0m58mqezba9yJq+rbNZTi7e5GftsNKuEar0VB7pUhERfp+GZe2/wwv65nZ0L/cy3yJrvAkfTheQbbkDaKmDHZE09xK2kfG7tXjbRe5Y5NwxZUvghvCnzzL0zO2fo09l/jhwBc/y3P7hf7K51MHUPzh/07eIP/CkH+TqvMfV5bNNvGOX+bM3S7wL8uf+WNvF4g5DsenH1/N7NauJbi9mn3kxz/8AWfcNV7KC2fLoXwGM+XuegE4qY+3TP8py002xcXhf7zV8U4fkBp/+82px4sflXU4LztFJRAbHaasBN93VZ76enV8lU4TxdUZkL0X/AAzLpl69+24vivvr3Tpyo15oxZUHxY8RIM6NIhTYdNDiTIcpo2JUSVG1CEzIjSWXEQ2X2HgUDFU6iSKi5r6/Pb8//VNvGOXGbMzAmdj/AFDe/nNp99fyJwIbJGwuI470rlriqLHBXH5PJmgMMgnxN17bahtsevy6mSevwTK7eN/CZy9DnnNHekeKPLrLDZOuDV666oj6r7cbctbkPn/dbZaIl/oTOb1f5I29nhXmhzrYOgPgL5Lw+Ft6maNuU5InHnIcqKi2D5qkbWdtBAhwbN/qvY1W27HZGkn6e2bbJ/w965l7dO6ZnMX02xcfFdEPOjxbmc9apWbvoTceVyHp0F5IcMXARNs1t1SmOVEaR3e19vYeMnoaqqA4pkCr1IemXq37bi+LTfXM6cvP1ZV1jTWEqpt4EyqtILpsTa2wjuxJsV5slE234z4g62QknT4dF+XXOpg/Hgb14L4G2Xmu6eNt0db4818Csd75FtU+za/rlLFT3pvZNd7WJNs6wBCyyKr0L6x9BFcpttNfytrM/h9HPm76VuG5RK/jShhUXHGiU8fTdLVmK0xZXtZXuET+y38kQF+ws7uWpPIbyqYNqg9emTrLJ15qNrLenC5P7ePk9XcbXUrhze7EYOp7bZfbdTtpTiBCotmldoSq6W6ZIEWBdkKELi/VGT/EqIfXM/bpmd05X02x0vDZn7lHjraTZsPyB06udsYYVsap5DjwW/edix4nVKjZvaaRSOG204rEkhRe1OwyXp8I9W88b+k763ynDj2ioqIqKioqdUVF6oqfSip8Uzdk+YAbrjTLTbjzz7gMsMtATrzzzi9rbLLQITjrrhL0ERRVVfhgd6fCThqJ40cRbRy9y3Ii6rcbRBZtbVbZQjFq2owAV6BBlmS+4k6weP3nGOikh+2CIp9Uzm9m3ft268N9J2zNcq/KzyDneRXKMvZmkkRNNomnqTRauQitus06PI5ItZjPVUbsbuQCOmPqrbQtgvqJZtpr2a4+WW23dfsrK7/luf3D/wBlcuq6meccOS343eIco2TBgNcq4pGSdER+Ro8CSy3/AHnGGDJP6EzH1eWzTbxjltmzMwO3v7f/AJcLt0GBwbyRa9+01UX2dEvrB5Pc2KoiNoga9KkOL1euquOH+ARL3yI49PU21U+b26Y/lOG2m2el5R37rKImncRIiIif71X6+idPVacFVf61Veq5Po+T2cRxTzoYmBM7H+ob385tPvr+ROBCr16L0+Py/ryRdPh3mjxd4jv6HdGuFOTNl3KiaYeizLvcqCVTQrkWBbeta6q7GUF4HVNWCdIlaQkVE7kRUy21326ZmF5trOuOq4N/+59xrtNJa65sPBm0W9HdwZFba1su618482DLbJp9hxEfEkQwL0IVQhXooqioi5SenaXMvVb+yX4c0+TLzgO4iI5xToHImm27tmkiQO0bXV31I1WE077kKDHiNDLadR8gVsjIkEBUVVV9c11m+f5WM7j4aXVEJFEkQhJFEhJEUSFU6KJIvVFRUX1TLoXg8ffO/lfhCFF1i2bDkbRoyC1Dqbuc+zdUjCF6t092QyHHYwD6BHkIQD19DFOiZnt6tduvFXm9n3i1+0eYXhDzXHGVzBxFet2wACg/L1tuwtBPsVtES71maL7wxxROxHDUenwH4pmc09mvjVrvpeY0vY8nfty64oWGt8Kbnu81sVNmtsgsK2AMhD6te8ttZxgIW1RC6ohp09Oi/DLY91+ZFc6fRXbmnyn3XlunZ0erqKTjPiqE6DkPjzTWBiQJZNICNP38xtqOds6hto52dgNe56khr0LL66TXrzUbbZ6cRWLLqv4QoSKJIiovoqL8FwL4cD+fPJ3E9Yxp+5QmeU9CaZ+xNV90+gbDWV5ILZwodo8DrNnCGOigEeYKoiEqK509My29c26zpV9d7Ol6xll5uv7cvIcty+utG5X41s5ZlImVeotONwjkvETj7is15WlaCqZfBrsbT+yKZGPbr0mKnPrqY1nyA8I+C3fxniLh/cd93COJFVbBvHtgdfJVOoL79ufdGFs+io4xFN4VT6qpi6ezbyskJdNeOVXOfvKflTyImthts9mn1WHIWRWaRQuPt0cZ1F6tyLF1zskXk5n+w6+giHxFsVRFy+mk045V22u34Vvy6rfnF+z+OevQ62VydxlyLvGxwrJyU+FPt1TUarOiAbJwokqufbSc4g9po8iGKOISIip0XKbTe+Nki07Vz+VfOfgLmbSYnH+8cAbm/r1YcV6jSq2ahq51BIgxigxZFNKZcMYrjMFw2ERQMPaNU6fRnr699bmXqtd5Zizo5177M45nW8d3jGi23X6EYDTcqHuNvAurN2yR11XpDMmuAGW4hMqCCCp3ISKvzTNpnH8uVOnwwjJQ/ZX2E+pnwrWrmSK+zrZcedXz4bpsS4U2K6L8aVGebUTafYeBCEkVFRUyPsLieRXlUHkNxNxPQXtfLi8h6XZWZ7VPFttKe7bOvbgxLaATa9zMmcIochlRFG3e7t+ooqtNNOy36Vfbbuk+ql+aKGBM7H+ob385tPvr+ROBDZIyPWNP2rdbAqnUNfs9kswZ98q+pY+0y/Z9wGe8WUITPq66Iog9VVVT0yLZOtMZ4Tm2cU8maHDbsN20TZdUhPSGorMi+rnK8XZD4SHGWmxeVHCV0IrqoqD2r7ZevVMiba3ipxZy/mpcV8lb9GdmaRouy7ZGYfKM87Q1zlgjT4CBG24DKq6KiLoqqqPT1T1xdpOaYrC58KZVzJdfZRZECfAfdizoUto48qJJYNQfjyGXEE2nmjFUIVRFRUyyGxGuFeXH6ZdjZ452p2gSMstboK7urBjIwslXSmI57I9I6d/aqofb69Mr3a5xnqnFaxX069fTp16qvwTp8eq/LplkN1UXjjztstBH2aj4r2+wppzSyK2S1Wq27axkHuKTVRHzal2EcU+JtgSdUXK3fWXFqe2/RrPYdW2PUpUWDs9JY0M2ZBYso0O0jOQ5TkGT19iT7DqC4DbvavTqidemTLLwjhMahxryFyAFg5o2l7HtrdT7f4odDWP2AV/vJ3NfbCaRRYRwU6p3dOqZF2mvNTJbwy//AMdeevbR3/lBv/tKvaj34BJ9pSX4Cjv+WpKvy69cjv0+sO3b6MI3DQN44+lQIW9alf6jLtIrs2tjX9e9XPT4bLqMPSooPIivMNvEgqSeiEuWll4RhK6pxHyjvVetrpegbTtVajz0cplFWOWLQvxyEH2zRhScBWjNEVVFE6r8ci7azpb1Ti3hjeyarsmnWS0+1Ulhr9qjQvlXWbKMSxZNSETNruJQRSFU6L0VFT1TJll6xDLqDhbl3aqWLsmt8a7jea/NJwId1XUsh+slG0ag4LEtERpwgNOioi/HIu2suLeqcXlNf+OfPneDa8O8go44iK22uvSkccRfgrYKne4i/wBCLkd+n1h236NX3ev3utXU7W9hqJ9JsFZIbiWNLZxzi2MKU80y+1HkxnOhsuuMyGzRF+Imi/PLSyzM4Q2OPj/zgcP8RDindzruz3PxAadwoCAnxNZqGsZBT5qpei5Xv1+sT21gNLqezbHdFrlDR2FvfActsqiC0Ls1HIKuDMD2u8UUo6tEhIiqvVPTrlrZJm8ISm28c79oKxh3fT77VDmEQRW72CUB18gHvJAZdX3fQPXqooip8MSy8JxY/bqvE/J29Vsi50zQdq2iohyihS7OlqX5sGNMFtt4or8ltPbbeFp0SUVXr0JMi7a69LepJbwyVfHTnsUAi4e5AEXfRoi1+SguqvwRol6I4q//AI9cjv0+sMVr3atO2zRrRKPc9budWuViszUq72C7XzlhyCdBiUkd5ENWHjYNBL4KoL9GWllmZwjjljeSJnY/1De/nNp99fyJwIbJGVaG89G3zRpcZ1yPKi7lrD8aSyZNPx3gu4Kg6y6Cobbg/SipkXhM5XB/cYkyJPkxbjIedfGFqeoRoYumppFjvU8eY6wwhdfbadlyDdJE9FM1X4rlPV4ftbfyaX8U7q2oPIfiyZTWEyuekbI1DmfZJL0YLCA5CnK7XTxaJBlwnvm24hCi/WREJEVLbyXS5+iNbjZcbyH481bym46f8oeE6wWdxoVereZtChKD1mxLrBX7TbFGZESenw4oo6TgCiTIPa8idwOKuetul7NuPhbaTad05VOpXXU8Nt6hi66kNfIrVXFiI4aRlcPRnDMiYRUaUjcBCXqnqSIvxy1/yz/8/wDan/n9tEafKpoO4ahN2NkZGuQts1qZsLBgrjbtDFu4D9y240ImTzZVrbvcCIquD1H55e8XHKJjPXh0x8yeAuXtp25PIjii+s+QdAsKmssNff0y1lJaaPWQq9tWfwSDWvtm1UttMq570NEMFRVeRC9Vx9e2snZt0rTbW2906xRLmzlWy5gvdW2W+OU/s9ZomuavtMyW0rL1hfUcdYs6wMC+shyzTuPr0Xv65rrr2zHxlS3PX5Y7RcnbXq+jX+ia5YzqKHtGwV95e2lRZz62zns1cFYkGlcehOsGlYDpm8Yof+KR9pooomTiW5pnphe7Z7m5D9tbRJwXNwE8uVWwKeFrYDOJtLm26NlMGSkkm06fwqfTMv8Adfwvm/1fv/tQ/bOTNo3jWdI1vaJsm6LQmr2JT3lpOlWN07WXs5qwKsly5ZOPOxa99pEY7jIhH069ETNZJOFLbeVuv24ZkuHz1djEkvxhk8bbOUkWXCbGQUMGXoiviKoLqxXvrN93XtL1TM/d4/tbTn9KMXxm9sOxyHjJ1+TsV7IkPGqk6++7ayzdedNfrG4ZL1VV9c1UZxc8tbzda9oenjsFzU61odO3SVVNUXNlBgSHXrWRYzLebGiPRmpE+U7IEepoftC2iASdyplZrJc/Kc3hdDz52PZabdOEJFLsuw0skOGtflBIqbuzrnRlosckld0SUz3v93qpF1Vfn165n6pLLn6rb2yzH0UX5E3m35M3O63rYED8c2AacrVwDU0lS6mgqqApxqoNp79g3Ui+6iCgo64XT06ZrJiYVtzc1evXH3x/a85GZGQ+LQ8y1sEWkec9sYL+16D78EG+7sCE97597SIjZd5dU+svXL/d+lv9f7c6676tjWKPUCasa82iBVAmzblMq2bZD0ICBU9FToqfLNlFh/MGZKsPJjlmVOkOypA2tFEB18ycMIsXUNeBiOCkqqDTadV7U6J3kRdO4lVc/X4RbbyaxZ5Q26Fx9X8b09vbUVFF2i72ux/B7mfXrez7atpquK1Yswzjd7FPGq3fbEjMHClkpAitgq27ZnPyjNxhfTyfu7yJ4i+IcyJeXUSY9GluPTIlvYxZjzgVRKBvSmJLch0wVEVFIlVFT0zPTz2X28YoLvvJGzckrp7+2THrSy0/TYmkMXEyS/Ms7Wsr77YryBItZUhSekTYrewrEQyIiJiM2pKpKS5rJJxwpbnlgOShM7H+ob385tPvr+ROBDZIyfSEUt20wRRVI9u1kAFPUiMruCIiKfFSJV6InzyLwmcrf/uJiQ+TV/3Io9+r6aQ9U6dwpQQwUh6/FEMVTr9KZT1eC2/k0Z4yMuyPIPiOOw2bz7u3Mi0y2Km44SV9gSoAJ6kqCKqv0ImW28L+FdeYk+BufNl8eeVJG2VCOWFFOnyavdtYJztj7BRfbpHeCAXVsLatV0nYrhJ0QlJsuguEqRtr3a4+U6263K53lXo/GFH42zOQeHrNiXovMXMWr7vBro4CDFHPPV7ODZ1rAJ0KMASopKUcxE4zik306Ci5lpb/AGY28pFtpO3M4rmbp9G1s+4afq78s69jZ9t1jWn7BtkZDkBnYL2BTuzm45uMhIOGE1XEbUwQ1HtUk69U3vSW/ZnOVjtR5r508NuQtj0ustpDldrd9YQLXRdi95/WbhuPINsJteyRG5UOz2ERwH4Ro2pH3ELq/Gl119kytm6XEba8/oGj2FtxDybrlC1qWycpaK3sm164MduJJ9x1WnItpYxm+0RnmTpsG52Cr3toZ9T6rkerOLLxKnfHSzmueuaqOj+0qiftl6ES+iLyu30VfRFRbm2RFRfgqL8vpzH/AHVe/wCL9/8AbnBmyi+n7dAkfPdsgCRKPGu3dyCiko97LIh16dencXon0rmXt8P2vpz+lHbr/wDuXyfMb66Ek+YkNpLQhVPkQqnRU+WaqI9v1dZRPiT7AonzUleBERPpVVwOgn7hoG1uPCQOgTZf8laIO0xUV7mljC4PQui9zar0JPl88x9PF/K/s5n4c+c2UdIOMo7+5/t0c2ahQik++1bkWv3GyrYyG9NbpI1pq105K+zgKmQlEoZKj29evtrmN6e2W8YXkzpcfVQTTNdu9u2ug1zWq2Xc3VncV8WHXwWTfkOvHLbToogi+2IIiqRF0QUReua3pM3hSTPSNreUlnX2/kRy7Nq5bM+EO2FWhMjGjkd9+jq62inEw4PVDaSwrXRFfmidcr65jST7LbeVaEVenqvoieqqvyy6rpL5T+nh74fdfTrDmdOvp17qgyHp1+PcPqn0pmWnns028I5tZqzMCZ2P9Q3v5zaffX8icCGyRlGo7nsuh27N/qk6LW3EdWjjTpNFrt8UV1h9qUxIiMbJU3ESJMYkMgbb7bYvAQ/VJMiyXpeEy44ZVyHzZyjyz7K8j7UG1vRyYJmdL1nToFqAxhkCwytzS67WW7kRtJbn+AT5MqpdVBVEVSJrNeC23lEaFybvPF9mt1oV2zr1x3IbVqmv6vc2EQ0Zej99dL2Kkt3qtw2JLgGUZWlMDVCVU9Mm6zbkls4QmzbTebjavXexSYcu0kJ0fkQaOg19p1e4jUzga3V09crpGaqR+z3kq+qriSTpEW5ftb3ra29Gk8bfjD56TJ2KPtf4E6gOR41/HjPxPxCEZD7sUpLEhUeAV9twkQlTu7lJiZ7vlOemPhB09rNobinvq0wasqG3q7ytdcbF1tqxp50eygOuNF9V0G5cUCUV9CROi/HHPRDfv/ldzPKfbmbHZalvNhFeN6utN84+03aLWq7nHHRYgWU2oGakRhx1SaaeN4GlRFBE6JlezX4zP2t3X5ac3Xedw5G2Kbtm87DYbNsM/sSRZWBtISNNp2sxo0aM0xDgxGB9AaZbbbFPgmWkkmJwi23rWMMvOR32JDSgjsd5mQ0rjTT7aOsOC60rjD4OsPgjgJ3A4JNmnoQqKqiyhu+Z5Lc4WGrjpE3doknTmx7WdYPQuMkpI6orhC7FgBpYMRJDZukQOtIDoEqkJIvrlezXOfn9rd1xj4aMX1VV+lVVf61XqvRPgiZZVtnjznTljiZl1njfbR1L7R7vvyoOsaXMtHgfcB11h26t9bsrlyKrgISMrIVkFT6oplbrrtymWzhg+0bXe7nbPXuySoc22k9ftEqFR0FAD5k4bpvPQtbqqevckuuuERuqz7rhKqkSrkySdIi3L6Ne2G21W1j3dG9Ej2cRHEjvTqekvo7fuj2kS1uw11tVuOCnqBmwRtkncCiXriyWYo2NyBz9zByrCZr+RdyTbI8YPbiHYato8efCa91t4mINvWaxAt4Mdx1oVNtl8APtTuRcia668Ra7W8tP5ZVsHjflXkLiK9XZOOton6zauM/ZpRRhjyYdjEVe4ollXTmZMGawq+qd7feC+oEK+uVus2mKmWzhsyz8q+YpsGxg1kzTdLO3Yfi2trx9x5qGmbDPiSkJJcV6/p6tq1bal96+4rTrZkqr9b1yOzVPdVcURERET4J/6+fquXVfsgTpNZOh2UImQlwJLEyKUiHCsI4yI7gutK/Aso8uvmtIYp3NPtONOJ6GJCqpkDcWz+R3Ne56yzpu1bs3d6tFi/YoNJK0zj1uJVxvsR1whTlE1GNJpXGoLpNNuRHGXWxX6hCqIqVmmsuZym7WzHw0ll0GBM7H+ob385tPvr+ROBDZIYDAYDAYDAYDAYDAYDAYDAYDAYDAYDAYDAYEzsf6hvfzm0++v5E4ENkhgMBgMBgMBgMBgMBgMBgMBgMBgMBgMBgMBgTOx/qG9/ObT76/kTgQ2SGAwGAwGAwGAwGAwGAwGAwGAwGAwGAwGAwGBM7H+ob385tPvr+ROBDZIYDAYDAYDAYDAYDAYDAYDAYDAYDAYDAYDAYEzsf6hvfzm0++v5E4ENkhgMBgMBgMBgMBgMBgMBgMBgMBgMBgMBgMBgf/2Q=="


export default defineComponent({
  name: "ProjectFundsPdfView",
  data() {
    return {
      pdfBlob: null,
      pdfUrl: null,
      isLoading: true,
    }
  },
  computed: {
    fundRequestId() {
      return this.$store.getters['pmLocalRequestFund/getRequestedFundId']
    },
    requestedFundData() {
      return this.$store.getters['pmLocalRequestFund/getRequestedFundData']
    },
    pmLocalTitle() {
      return this.$store.getters["pmLocalModules/isPmLOcalTitle"];
    },
    docContent() {
      return [
        // Title
        {
          text: 'REQUEST FOR PROJECT FUNDS',
          style: 'header',
          alignment: 'center',
          margin: [0, 0, 0, 20]
        },

        // Project Information Section
        {
          layout: 'noBorders',
          table: {
            widths: [80, '*'],
            body: [
              [
                { text: 'KST:', bold: true },
                { text: this.requestedFundData?.cost_centre || "-" }
              ],
              [
                { text: 'Title:', bold: true },
                { text: this.requestedFundData?.project_title || "-" }
              ],
              [
                { text: 'Location:', bold: true },
                { text: (this.requestedFundData?.location?.country || "-") + ", " + (this.requestedFundData?.location?.place || "-") }
              ],
              [
                { text: 'Period:', bold: true },
                { text: `${this.requestedFundData?.start_date?.formattedDate()} - ${this.requestedFundData?.end_date?.formattedDate()}` }
              ]
            ]
          },
          margin: [0, 0, 0, 10]
        },

        // Date of Transfer and Invoice Number Row
        (this.requestedFundData?.is_paid ? {
          layout: 'noBorders',
          table: {
            widths: [120, 220, '*', 100],
            body: [
              [
                { text: 'Date of transfer:', bold: true },
                { text: this.requestedFundData?.transfer_date?.formattedDate() },
                { text: 'No. incoming invoice:', bold: true, alignment: 'right' },
                { text: this.requestedFundData?.invoice_number, alignment: 'right' }
              ],
              [
                { text: 'Transfer to:', bold: true },
                { text: this.requestedFundData?.transfer_to || "-" },
                { text: '' },
                { text: '' }
              ],
              [
                { text: 'Account bank:', bold: true },
                { text: this.requestedFundData?.bank_name || "-" },
                { text: '' },
                { text: '' }
              ]
            ]
          },
          margin: [0, 0, 0, 10]
        }: { text: '' }),

        // Financial Table
        {
          table: {
            widths: ['*', 100, 80],
            headerRows: 1,
            body: [
              [
                { text: '', border: [true, true, true, true] },
                { text: 'amount', bold: true, alignment: 'right', border: [true, true, true, true] },
                { text: 'account assignment', bold: true, alignment: 'right', border: [true, true, true, true] }
              ],
              [
                { text: `local project funds ${this.requestedFundData?.currency}:`, bold: true },
                { text: (this.requestedFundData?.total_requested_amount || 0)?.germanCurrencyFormatter(), alignment: 'right' },
                { text: this.requestedFundData?.fund_account_number, alignment: 'right' }
              ],
              [
                { text: `minus cash/bank account balance ${this.requestedFundData?.currency}:`, bold: true },
                { text:( this.requestedFundData?.total_reduced_amount || 0)?.germanCurrencyFormatter(), alignment: 'right' },
                { text: this.requestedFundData?.fund_account_number, alignment: 'right' }
              ],
              [
                { text: `TOTAL AMOUNT ${this.requestedFundData?.currency}:`, bold: true },
                { text: (this.requestedFundData?.total_approved_amount || 0)?.germanCurrencyFormatter(), alignment: 'right', bold: true },
                { text: ""}
              ]
            ]
          },
          margin: [0, 0, 0, 10]
        },

        // Signature and Bank Details Section
        {
          columns: [
            // Left Column - Signatures
            {
              width: '50%',
              stack: [
                {
                  layout: 'noBorders',
                  table: {
                    widths: [60, '*'],
                    body: [
                      [
                        { text: 'Date:', bold: true },
                        { text: this.requestedFundData?.requester_signed_date?.formattedDate() || "-" }
                      ],
                      [
                        { text: '', colSpan: 2 },
                        {}
                      ],
                      [
                        { text: 'Name:', bold: true },
                        { text: `${this.requestedFundData?.fund_requester?.title} ${this.requestedFundData?.fund_requester?.first_name} ${this.requestedFundData?.fund_requester?.middle_name} ${this.requestedFundData?.fund_requester?.last_name}` }
                      ],
                      [
                        { text: '', colSpan: 2 },
                        {}
                      ],
                      [
                        { text: '', colSpan: 2 },
                        {}
                      ],
                      [
                        { text: 'Sign.:', bold: true },
                        // { text: '__________text______________________' }
                        (this.requestedFundData?.fund_requester?.signature_base64 ? { image: this.requestedFundData?.fund_requester?.signature_base64, fit: [100, 40]} : { text: '________________________________' })
                      ]
                    ]
                  },
                  margin: [0, 0, 0, 20]
                },
              ]
            },

            // Right Column - Bank Details
            {
              width: '50%',
              stack: [
                {
                  layout: 'noBorders',
                  table: {
                    widths: [100, '*'],
                    body: [
                      [
                        { text: 'Account Holder:', bold: true },
                        { text: this.requestedFundData?.account_owner }
                      ],
                      [
                        { text: 'Bank:', bold: true },
                        { text: this.requestedFundData?.bank_name }
                      ],
                      [
                        { text: 'City of the bank:', bold: true },
                        { text: this.requestedFundData?.city_of_bank }
                      ],
                      [
                        { text: 'BIC/SWIFT:', bold: true },
                        { text: this.requestedFundData?.swift_code}
                      ],
                      [
                        { text: 'Account No.:', bold: true },
                        { text: this.requestedFundData?.account_number }
                      ],
                      [
                        { text: 'IBAN:', bold: true },
                        { text: this.requestedFundData?.iban }
                      ]
                    ]
                  }
                }
              ]
            }
          ],

        },
        {
          text: 'Signature ICON-INSTITUT GmbH:',
          bold: true,
          margin: [0, 0, 0, 10]
        },
        {
          layout: 'noBorders',
          table: {
            widths: ["*", "*", "*", "*"],
            body: [
              [
                (this.requestedFundData?.controller_to_sign?.signature_base64 ? {image: this.requestedFundData?.controller_to_sign?.signature_base64, fit: [100, 40], alignment: "center"} : { text: '________________________________' }),
                (this.requestedFundData?.pm_to_sign?.signature_base64 ? {image: this.requestedFundData?.pm_to_sign?.signature_base64, fit: [100, 40], alignment: "center"} : { text: '________________________________' }),
                (this.requestedFundData?.ceo_to_sign?.signature_base64 ? {image: this.requestedFundData?.ceo_to_sign?.signature_base64, fit: [100, 40], alignment: "center"} : { text: '________________________________' }),
              ],
              [
                { text: `${this.requestedFundData?.controller_to_sign?.title} ${this.requestedFundData?.controller_to_sign?.first_name} ${this.requestedFundData?.controller_to_sign?.middle_name ? this.requestedFundData?.controller_to_sign?.middle_name + " " : ""}${this.requestedFundData?.controller_to_sign?.last_name}`, alignment: 'center' },
                { text: `${this.requestedFundData?.pm_to_sign?.title} ${this.requestedFundData?.pm_to_sign?.first_name} ${this.requestedFundData?.pm_to_sign?.middle_name ? this.requestedFundData?.pm_to_sign?.middle_name + " " : ""}${this.requestedFundData?.pm_to_sign?.last_name}`, alignment: "center" },
                { text: `${this.requestedFundData?.ceo_to_sign?.title} ${this.requestedFundData?.ceo_to_sign?.first_name} ${this.requestedFundData?.ceo_to_sign?.middle_name ? this.requestedFundData?.ceo_to_sign?.middle_name + " " : ""}${this.requestedFundData?.ceo_to_sign?.last_name}`, alignment: "center" },
              ],
              [
                {text: "Controller", alignment: 'center'},
                {text: "Project Manager", alignment: "center"},
                {text: "CEO", alignment: "center"},
              ],
              [
                { text: this.requestedFundData?.controller_signed_date?.formattedDate(), alignment: 'center' },
                { text: this.requestedFundData?.pm_signed_date?.formattedDate(), alignment: "center" },
                { text: this.requestedFundData?.ceo_signed_date?.formattedDate(), alignment: "center" },
              ]
            ]
          },
          margin: [0, 0, 0, 10]
        },
      ]
    }
  },
  mounted() {
    this.generatePdf();
  },
  methods: {
    htmlToPdfMake (content) {
      return {
        pageSize: {
          width: 841.89,
          height: 595.28
        },
        pageOrientation: 'landscape',
        pageMargins: 25,
        footer: function (currentPage, pageCount) {
          return {
            text: `Page ${currentPage.toString()} of ${pageCount}`,
            alignment: "center",
            fontSize: 10,
            color: "gray",
          };
        },
        content,
        defaultStyle: {
          fontSize: 12,
        },
        styles: {
          header: {
            fontSize: 12,
            bold: true,
            alignment: "center",
          },
          paragraph: {
            fontSize: 12,
            margin: [0, 5, 0, 5],
          },
        },
        images: {
          IconLogoBase64
        }
      };
    },
    async generatePdf() {
      try {
        await this.$store.dispatch('pmLocalRequestFund/fetchOneRequestedFund', {foreignEstablishment: this.fundRequestId})
        const docDefinition = this.htmlToPdfMake(this.docContent);
        const pdfDoc = pdfMake.createPdf(docDefinition);
        pdfDoc.getBlob((blob) => {
          if (this.pdfUrl) {
            URL.revokeObjectURL(this.pdfBlob);
          }
          this.pdfBlob = blob;
          this.pdfUrl = URL.createObjectURL(blob);
        });
      } catch (error) {
        console.error('Error generating PDF:', error);
      } finally {
        this.isLoading = false;
      }
    },
    handleGoToBack() {
      this.$router.go(-1);
    },
  },
  beforeUnmount() {
    // Clean up blob URL
    if (this.pdfBlob) {
      URL.revokeObjectURL(this.pdfBlob);
    }
  }
});
</script>

<template>
  <main>
    <div
      v-if="isLoading"
      class="h-[500px] flex justify-center items-center"
    >
      <app-loader></app-loader>
    </div>
    <div v-else ref="page" class="w-full">
      <app-header
        class="!py-4 !px-10"
        :name="pmLocalTitle"
        :clickEvent="handleGoToBack"
        :show-arrow-back="true"
      >
      </app-header>
    <div class="px-10">
      <iframe
        class="mt-10"
        title="PDF Preview"
        v-if="pdfUrl"
        :src="pdfUrl"
        width="100%"
        height="800px"
        style="border: none"
      ></iframe>
    </div>
    </div>
  </main>
</template>

<style scoped></style>
